import { render, staticRenderFns } from "./SecondBanner.vue?vue&type=template&id=e4f85d90&scoped=true"
import script from "./SecondBanner.vue?vue&type=script&lang=js"
export * from "./SecondBanner.vue?vue&type=script&lang=js"
import style0 from "./SecondBanner.vue?vue&type=style&index=0&id=e4f85d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f85d90",
  null
  
)

export default component.exports